import React, {useEffect, useState} from 'react';
import OnboardInput from "../base/onboard-input/OnboardInput";
import OnboardSelect from "../base/onboard-select-component/OnboardSelect";
import {useTranslation} from "react-i18next";
import {isEmpty, isSeatNumber} from "../../util/Validation";

const SeatOrTicketNumberComponent = (props) => {
    const {t, i18n} = useTranslation();
    const {
        valueSeatNumber,
        valueTicketNumber,
        changeSeatNumber,
        changeTicketNumber,
        changeOption,
        errorSeatNumber,
        errorTicketNumber,
    } = props;

    const [seatNumber, setSeatNumber] = useState(valueSeatNumber === undefined ? null : valueSeatNumber);
    const [ticketNumber, setTicketNumber] = useState(valueTicketNumber === undefined ? null : valueTicketNumber);

    useEffect(() => {
        setSeatNumber(valueSeatNumber);
    }, [valueSeatNumber])

    useEffect(() => {
        setTicketNumber(valueTicketNumber);
    }, [valueTicketNumber])

    const handleSeatNumber = (val) => {
        setSeatNumber(val);
        if (changeSeatNumber !== undefined)
            changeSeatNumber(val);
    }

    const handleTicketNumber = (val) => {
        setTicketNumber(val);
        if (changeTicketNumber !== undefined)
            changeTicketNumber(val);
    }

    const handleSelectEnterOption = (val) => {
        setSelectEnterOption(val);
        if (changeOption !== undefined)
            changeOption(val);
    }

    const [selectEnterOption, setSelectEnterOption] = useState({value: '1', label: t('login.seat_number_option')});
    const enterOptions = [
        {value: '1', label: t('login.seat_number_option')},
        {value: '2', label: t('login.ticket_number_option')}
    ];
    useEffect(() => {
        if (selectEnterOption.value === '1') setVisibleOptions(true);
        else setVisibleOptions(false);
    }, [selectEnterOption]);
    const [visibleOptions, setVisibleOptions] = useState(true);

    useEffect(() => {
        if (selectEnterOption.value === "1")
            setSelectEnterOption({value: '1', label: t('login.seat_number_option')});
        else setSelectEnterOption({value: '2', label: t('login.ticket_number_option')});
    }, [i18n.language]);

    return (
        <div>
            <OnboardSelect placeholder={t('login.enter_option')} options={enterOptions}
                           value={selectEnterOption}
                           onChange={(e) => handleSelectEnterOption(e)}/>

            <div className="h-8"/>

            {props.children}

            {visibleOptions && (
                <OnboardInput placeholder={t('login.seat_number')} onChange={(e) => handleSeatNumber(e)}
                              error={errorSeatNumber} hint
                              validation={isSeatNumber(seatNumber, t('error.valid_seat_number'), t('error.empty_seat_or_ticket_number'))}
                              mask={{
                                  mask: "9{1,2}a",
                                  definitions: {"a": {casing: "upper", validator: "[A-Ka-k]"}}
                              }}
                              value={seatNumber}/>
            )}
            {!visibleOptions && (
                <OnboardInput placeholder={t('login.ticket_number')} onChange={(e) => handleTicketNumber(e)}
                              error={errorTicketNumber}
                              validation={isEmpty(ticketNumber, t('error.empty_ticket_number'))}
                              mask={{mask: "9{1,13}"}}
                              value={ticketNumber}/>
            )}
        </div>
    )
};

export default SeatOrTicketNumberComponent;



